// KL - freelance personal trainer. Client-facing; no trainer list.
const content = {
    slug: 'freelance-personal-trainer',
    title: 'Freelance Personal Trainer in KL | Hire One Who Comes to You',
    description: (c) =>
        `Hiring a freelance personal trainer in KL: how they compare with gym PT, what to check, and packages from ${c.money(c.lowest, 0)} a session with no gym membership.`,
    eyebrow: 'KL · Freelance trainer',
    h1: 'Freelance Personal Trainer in Kuala Lumpur',
    lead: 'With most KL condos having a gym of their own, a freelance trainer who meets you downstairs often makes more sense than a gym membership plus gym PT across town.',
    image: 'personal-trainer/personal-trainer-png.png',
    imageAlt: 'Freelance personal trainer ready for a session',
    facts: ['Uses your condo gym', 'No membership', 'Checked certifications'],
    matchSummary: 'a freelance personal trainer in KL',
    trainerCta: true,
    packagesTitle: 'Freelance trainer packages',
    sections: [
        {
            title: 'Freelance trainer vs gym PT in KL',
            cards: [
                { title: 'Cost', body: 'Gym PT usually means a membership plus a session bundle. Freelance means sessions only.' },
                { title: 'Location', body: 'Your condo gym, home or a park nearby - no driving through KL traffic.' },
                { title: 'Sales pressure', body: 'No upselling of supplements or longer contracts at the counter.' },
                { title: 'Equipment', body: 'Big gyms have more machines; most goals need far less than you think.' },
            ],
            cardColumns: 2,
        },
        {
            title: 'What to check',
            tone: 'muted',
            items: [
                'A recognised certification - for example NASM, ACE, ISSA, or a coaching certificate recognised by the National Sports Council.',
                'First aid and CPR.',
                'Experience with your goal: weight loss, rehab, pregnancy, seniors.',
                'Clear terms on cancellations and refunds.',
            ],
        },
        {
            title: 'How StringsSG fits in',
            paragraphs: [
                'We check every trainer\'s certification before they join, set fixed rates, and handle scheduling and payment. If the match isn\'t right, we find you another trainer - no awkward conversations.',
            ],
        },
    ],
    faqs: [
        {
            question: 'Are freelance personal trainers in Malaysia certified?',
            answer: 'Many are, but not all - there is no single mandatory licence. Ask for certificates; ours are checked before they join.',
        },
        {
            question: 'Can a freelance trainer use my condo gym?',
            answer: 'Usually yes. Some condos require visitor registration or limit outside trainers - check with management.',
        },
        {
            question: 'I\'m a trainer in KL - can I join?',
            answer: 'Yes, we\'re building our founding team. Apply using the link at the bottom of this page.',
        },
    ],
    schema: { name: 'Freelance Personal Trainer in Kuala Lumpur' },
}

export default content
